<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{commandeLine.title}}
      <img *ngIf="commandeLine.is_sac_orange" class="orange" src="assets/img/new-sac.png"
        matTooltip="Les articles doivent être retournés dans le sac plastique orange">
    </mat-panel-title>
    <mat-panel-description>
      <div *ngIf="commandeLine.nom_prenom_porteur">
        {{commandeLine.nom_prenom_porteur}}
      </div>
      <div *ngIf="commandeLine.client">
        Client {{commandeLine.client.code_client}}/{{commandeLine.client.code_service}}
      </div>
      <mat-icon id="warn" matTooltip="Cette demande sera supprimée demain si le panier n'est pas validé"
        *ngIf="notifyBeforeDelete()">
        schedule
      </mat-icon>
      <div style="width: 40px" *ngIf="!notifyBeforeDelete()"></div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <p>
    <button mat-raised-button color="warn" (click)="deleteLine()" class="button-icon">
      <mat-icon>delete</mat-icon>
    </button>
    {{commandeLine.objetdemande}}
  </p>

</mat-expansion-panel>